import { render, staticRenderFns } from "./TrainingPlanPages.vue?vue&type=template&id=1ab653c6&scoped=true&"
import script from "./TrainingPlanPages.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanPages.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlanPages.vue?vue&type=style&index=0&id=1ab653c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab653c6",
  null
  
)

export default component.exports